import React, { useEffect, useState, useContext } from "react";
import { Container } from "react-bootstrap";
import { toast } from "react-hot-toast";
import API from "../../../utils/API";
import PsContext from "../../../context/PsContext";
import NO_PRODUCT_IMG from "../../../assets/img/empty.webp";
import ProductLoader from "../../pages/Home/productLoader";
import { makeUrl } from "../../../utils";
import { Link, withRouter } from "react-router-dom";
const WishList = () => {
  const context = useContext(PsContext);
  const [wishlistItems, setWishlistItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchWishlist = async () => {
    setLoading(true);
    let customerid = null;

    if (context.state && context.state.userData && context.state.userData.id) {
      customerid =
        context.state && context.state.userData && context.state.userData.id;
    } else if (localStorage.getItem("customerData")) {
      customerid = JSON.parse(localStorage.getItem("customerData")).id;
    }

    if (!customerid) {
      toast.error("Please login to view your wishlist.");
      setLoading(false);
      return;
    }

    try {
      const res = await API.post(`v1/site/whishlist/list`, {
        customerid: customerid,
      });

      const response = res.data;

      if (response.status === "1") {
        setWishlistItems(response.data);
      } else {
        toast.error(response.message || "No items found in wishlist.");
      }
    } catch (error) {
      console.error("Wishlist fetch error:", error);
      toast.error("Something went wrong while loading your wishlist.");
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchWishlist();
  }, [context.state]);

  const deleteWish = async (itemid) => {
    const customerData = localStorage.getItem("customerData");
    const customerid =
      (context.state && context.state.userData && context.state.userData.id) ||
      (customerData ? JSON.parse(customerData).id : null);

    if (!customerid) {
      toast.error("Please login to remove from wishlist.");
      return;
    }

    const postData = new FormData();
    postData.append("customerid", customerid);
    postData.append("itemid", itemid);

    try {
      const res = await API.post("v1/site/whishlist/delete", postData);

      if (res.data.status === "1") {
        setWishlistItems((prev) => prev.filter((item) => item.id !== itemid));
        toast.success("Removed from wishlist.");
      } else {
        toast.error(res.data.message || "Error removing item.");
      }
    } catch (error) {
      console.error("Delete wishlist error:", error);
      toast.error("Something went wrong.");
    }
  };

  const addToCart = (item) => {
    item.quantity = 1;
    context.addToCart(item);
    toast.success("Added to cart.");
  };

  return (
    <div>
      <div className="tf-page-title mb-50">
        <div className="container-full">
          <div className="heading text-center">My Wishlist</div>
          <p className="text-center text-2 text_black-2 mt_5">Saved Products</p>
        </div>
      </div>

      <Container className="my-4">
        {loading && <ProductLoader size={8} />}

        {!loading && wishlistItems.length > 0 && (
          <div
            className="grid-layout loadmore-item wow fadeInUp"
            data-wow-delay="0s"
            data-grid="grid-5"
          >
            {wishlistItems.map((product) => (
              <div key={product.id} className="card-product">
                <div className="card-product-wrapper">
                  <Link
                    to={`/${makeUrl(product.slug)}/p/${product.id}`}
                    className="product-img"
                  >
                    <img
                      className="lazyload img-product"
                      src={`https://shibanifashion.com/files_list/${product.image}`}
                      alt={product.itemname}
                    />
                    {product.image1 && (
                      <img
                        className="lazyload img-hover"
                        src={`https://shibanifashion.com/files_list/${product.image1}`}
                        alt={product.itemname}
                      />
                    )}
                  </Link>
                  <div className="list-product-btn absolute-2">
                    {product.stockinhand &&
                    parseFloat(product.stockinhand) > 0 ? (
                      <a
                        onClick={() => addToCart(product)}
                        className="box-icon bg_white quick-add tf-btn-loading"
                      >
                        <span className="icon icon-bag"></span>
                        <span className="tooltip">Add to Cart</span>
                      </a>
                    ) : (
                      <span className="out-of-stock text-danger small text-white fw-bolder">
                        Out of Stock
                      </span>
                    )}

                    <a
                      onClick={() => deleteWish(product.id)}
                      className="box-icon bg_white quick-add tf-btn-loading"
                    >
                      <span className="icon icon-delete"></span>
                      <span className="tooltip">Remove from Wishlist</span>
                    </a>
                  </div>
                </div>

                <div className="card-product-info">
                  <Link
                    to={`/category/${makeUrl(product.slug)}`}
                    className="title link"
                  >
                    {product.itemname}
                  </Link>
                  <span className="price">
                    ₹{" "}
                    {product.salesdiscount > 0
                      ? product.discount_sales_rate
                      : product.salesrate}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}

        {!loading && wishlistItems.length === 0 && (
          <div className="text-center">
            <img
              src={NO_PRODUCT_IMG}
              alt="No products"
              style={{ width: "100%", maxWidth: "300px" }}
            />
            <h4 className="mt-4">Your wishlist is empty.</h4>
          </div>
        )}
      </Container>
    </div>
  );
};

export default WishList;
